import React from "react";
import { string, func, bool } from "prop-types";
import { MenuItem } from "#library/components/Menu/MenuItem";
import { Icon } from "#library/components/Icon/Icon";
import { DATA_SPACER } from "#library/constants/enums";
import IconArrowDown from "#library/assets/icons/jds_arrowDown.svg";
export var ButtonShowAll = function ButtonShowAll(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(MenuItem, {
    as: "button",
    onClick: onClick,
    selected: selected,
    className: className
  }, label, /*#__PURE__*/React.createElement(Icon, {
    xlinkHref: "#".concat(IconArrowDown.id),
    dataSpacer: DATA_SPACER.LEFT_50
  }));
};
ButtonShowAll.propTypes = {
  className: string,
  label: string.isRequired,
  onClick: func.isRequired,
  selected: bool
};